export default {
  CUSTOM_GOAL_TYPES_REPOSITORY: Symbol.for('CUSTOM_GOAL_TYPES_REPOSITORY'),
  GET_CUSTOM_GOAL_TYPES_QUERY: Symbol.for('GET_CUSTOM_GOAL_TYPES_QUERY'),
  CUSTOM_GOAL_TYPES_STATE_MANAGER: Symbol.for('CUSTOM_GOAL_TYPES_STATE_MANAGER'),
};
